const LForms = window.LForms;

export default LForms;